<template>
    <v-list expand>
        <v-list-group
            :value="true"
            :ripple=false
            color="black"
        >
            <template v-slot:activator>
                <v-list-item-title>
                    <TitleFilter
                        class="d-inline"
                        :filterType="sliderType"
                    />
                    <SwitchAreaUnit
                        v-if="language === 'en' && areaUnit"
                        :areaUnit="areaUnit"
                        class="d-inline ml-2"
                        location="sidebar"
                    />
                </v-list-item-title>
            </template>

            <v-card-text
                class="pa-0 pt-4"
                :class="{ 'px-3': isAlternativeMode }"
            >
                <v-row justify="space-between">
                    <v-col class="text-left">
                        <span v-text="currentMin"/>
                    </v-col>
                    <v-col class="text-right">
                        <span v-text="currentMax"/>
                    </v-col>
                </v-row>
                <div :id="gtmTrackerId">
                    <v-range-slider
                        v-model="range"
                        :min="min"
                        :max="max"
                        :step="stepByType"
                        hide-details
                        @change="filterBy(range[0], range[1])"
                    />
                </div>
            </v-card-text>
        </v-list-group>
    </v-list>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import TitleFilter from "@/components/filters/TitleFilter";
    import SwitchAreaUnit from "@/components/filters/SwitchAreaUnit";

    export default {
        name: "SliderFilter",
        components: {
            SwitchAreaUnit,
            TitleFilter
        },
        props: {
            areaUnit: {
                type: String,
                required: false
            },
            min: {
                type: Number,
                required: false,
            },
            max: {
                type: Number,
                required: false,
            },
            userFilter: {
                type: Object,
                required: false
            },
            sliderType: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                range: [
                    this.$props.userFilter ? this.$props.userFilter.min : this.$props.min,
                    this.$props.userFilter ? this.$props.userFilter.max : this.$props.max,
                ]
            }
        },
        computed: {
            ...mapGetters([
                'language',
                'isAlternativeMode'
            ]),
            suffixSlider() {
                switch (this.$props.sliderType) {
                    case 'area':
                        return this.$props.areaUnit;
                    case 'price':
                    case 'rent':
                        return '€';
                }
            },
            stepByType() {
                switch (this.$props.sliderType) {
                    case 'area':
                        return 2;
                    case 'price':
                    case 'rent':
                        return 1000;
                }
            },
            currentMin() {
                return this.range ? this.range[0] + ' ' + this.suffixSlider : null;
            },
            currentMax() {
                return this.range ? this.range[1] + ' ' + this.suffixSlider : null;
            },
            gtmTrackerId() {
                return `gtm-filter-${this.sliderType}`;
            }
        },
        created() {
            EventBus.$on('resetSliders', this.resetRange);
        },
        methods: {
            resetRange() {
                this.$set(this.range, 1, this.$props.min);
                this.$set(this.range, 0, this.$props.max);
            },
            filterBy(min, max) {
                this.$emit('filter-method', min, max);
            }
        },
        watch: {
            areaUnit() {
                this.resetRange();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-list-item__title {
        color: unset !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/filters/SliderFilter.vue